<template>
    <v-card flat>
        <v-card-title class="subheader py-0">
            <v-icon small class="mr-1" color="indigo">view_list</v-icon>
            基本信息
            <v-spacer/>
        </v-card-title>
        <v-divider color="indigo"/>
        <v-card-text class="pt-0">
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <div class="x-text-field">
                            <label>姓名</label>
                            <div>{{item.name}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <div class="x-text-field">
                            <label>工号</label>
                            <div>{{item.number}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <div class="x-text-field">
                            <label>所在学院</label>
                            <div>{{item.department?item.department.name:""}}</div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <div class="x-text-field">
                            <label>政治面貌</label>
                            <div>{{item.politics}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12>
                        <div class="x-text-field">
                            <label>列入黑名单原因</label>
                            <div>{{item.reason}}</div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <div class="x-text-field">
                            <label>列入日期</label>
                            <div>{{item.startDate}}</div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <div class="x-text-field">
                            <label>截止日期</label>
                            <div>{{item.endDate}}</div>
                        </div>
                    </v-flex>


                    <v-flex xs12>
                        <div class="x-text-field">
                            <label>处理建议</label>
                            <div>{{item.suggestion}}</div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "basic",
        props: {
            infoBasic: Object
        },

        data: () => ({
            item: {},
        }),

        watch: {
            infoBasic(v) {
                if (v) this.item = v;
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>